<template>
  <v-btn
    depressed
    large
    dark
    rounded
    height="48px"
    class="btn-seven-club-plus"
    @click="goTo7ClubPlus"
  >
    <span>
      สมัครสมาชิก 7Club+
    </span>
  </v-btn>
</template>

<script>
import isBnn from '@/config/isBnn'

export default {
  name: 'BaseSevenClubPlusButton',
  data() {
    return {
      baseUrl:
        process.env.VUE_APP_7_CLUB_PLUS_URL ||
        'https://7clubplus.com/th',
      params: {
        'dialog-login-type': 'register',
        preorder: isBnn ? 'bnn' : 'stu',
        slug: this.$route.params.slug,
        store_id: '99005',
      },
    }
  },
  computed: {
    url() {
      return `${this.baseUrl}?${new URLSearchParams(this.params)}`
    },
  },
  methods: {
    goTo7ClubPlus() {
      if (!this.$route.params.slug) return

      window.open(this.url, '_blank')
    },
  },
}
</script>
